import { WifiStrengthAlertOutlineIcon } from './WifiStrengthAlertOutlineIcon';

/**
 * author: Simran
 * id 50E531C4-A82A-4F0C-A8BB-A2208B546E81
 * name wifi-strength-alert-outline
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const WifiStrength0WarningIcon = WifiStrengthAlertOutlineIcon;
export default WifiStrength0WarningIcon